import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../i18n/LanguageContext";

export function Error({
   title,
   subTitle,
   extra = [],
   icon,
   status = 500,
   hasBackButton = false
}) {
   const navigate = useNavigate();
   const { t } = useTranslation();

   return (
      <Result
         status={status === "401" ? "403" : status}
         title={title ?? t("error-oops-title")}
         subTitle={subTitle ?? t("error-something-wrong-text")}
         icon={icon}
         extra={
            hasBackButton
               ? [
                    ...extra,
                    <Button key="back-home" onClick={() => navigate("/")}>
                       {t("back-home-button")}
                    </Button>
                 ]
               : extra
         }
      />
   );
}
